import React from 'react';

const Icon = ({ size = '49', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 49 49" fill="none" {...other}>
            <g clipPath="url(#a)">
                <path
                    d="m41.177 11.873-10.622-.672-21.65 15.732 9.547 1.613m22.724-16.673c-1.705 2.286-6.137 7.598-10.222 10.556-1.418 1.026-3.06 1.98-4.703 2.821m14.925-13.377L18.453 28.546m0 0c1.61-.527 4.706-1.713 7.799-3.296m0 0v11.902m0 0-15.194 4.84m15.194-4.84 13.715 4.303m-13.715-4.303-7.799 9.009"
                    stroke={fill}
                    strokeWidth="1.793"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path d="M19.138 15.288a1.406 1.406 0 1 0-1.874-2.097 1.406 1.406 0 0 0 1.874 2.097Z" fill={fill} />

                <path
                    d="M18.25 4.396a9.807 9.807 0 0 0-6.61 2.505 9.807 9.807 0 0 0-3.229 6.3m10.472-3.835a4.911 4.911 0 0 0-3.963 1.204 4.913 4.913 0 0 0-1.635 3.938"
                    stroke={fill}
                    strokeWidth="1.688"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M1.471 2.078h45v45h-45z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
